export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            { "name": "code", "tableName": "IDWEEKSETTINGSHEADER", "label": "Code", "type": "text", "required": false, "visible": true, "isLabelChanged": false },
        ]
    },
    {
        "groupId": 2,
        "fields": [
            { "name": "status", "tableName": "IDWEEKSETTINGSHEADER", "label": "Status", "type": "select", "required": false, "visible": true, "isLabelChanged": false },
        ]
    },
        {
        "groupId": 3,
        "fields": [
            { "name": "description1", "tableName": "IDWEEKSETTINGSHEADER", "label": "Description 1", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            { "name": "description2", "tableName": "IDWEEKSETTINGSHEADER", "label": "Description 2", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    }
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CODE",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "DESCRIPTION1",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION2",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "IDWEEKSETTINGSHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];
